import { Alert, Col, Row } from 'reactstrap';
import DataTable from "components/Core/DataTable";
import { useRef, useMemo, useState, useEffect } from "react";

const PurchaseOrderDetail = (props) => {
  const { data } = props;
  const table = useRef(null);
  const [subTotalTotal, setSubTotalTotal] = useState(0)
  const [discountTotal, setDiscountTotal] = useState(0)
  const [totalTotal, setTotalTotal] = useState(0)
  const dollar = useMemo(() => Intl.NumberFormat('en-US', {
    style: "currency",
    currency: "USD",
  }), []);
  const headers = [
    { title: 'Card Identifier', data: 'cardIdentifier', searchable: true, sortable: true },
    { title: 'Origin', data: 'supplierOrderIdentifier', searchable: true, sortable: true,
      render: data => {
        return data?.includes('STOCK') ? 'Stock' : data ? 'Supplier' : 'Not Available'
      }
    },
    { title: 'Card', data: 'productName', searchable: true, sortable: true },
    { title: 'Supplier\nFee / Discount', data: 'supplier', searchable: true, sortable: true },
    { title: 'Qty', data: 'quantity', searchable: true, sortable: true },
    { title: 'Amount', data: 'amount', sortable: true, render: data => data ? dollar.format(data) : 0 },
    { title: 'Sub total', data: 'subtotal', searchable: true, sortable: true },
    { title: 'Discount', data: 'discount', searchable: true, sortable: true },
    { title: 'Total', data: 'total', searchable: true, sortable: true },
  ]
  useEffect(() => {
    let totalTmp = 0
    let discountTmp = 0
    let subTotalTmp = 0

    data.map(item =>{
      totalTmp = totalTmp + item.total
      discountTmp = discountTmp + item.discount
      subTotalTmp = subTotalTmp + item.subtotal
    })
    setSubTotalTotal(subTotalTmp)
    setDiscountTotal(discountTmp)
    setTotalTotal(totalTmp)

  }, ['data'])
  return (
    <>
      <Row className="justify-content-between m-4">
        <Col>
          <div>
            <h4>Summary</h4>
            <DataTable
              options={{
                searching: false,
                responsive: true,
                info: false,
                dom: "tip"
              }}
              ref={table}
              data={data}
              columns={headers}
            />
          </div>
        </Col>
      </Row>
      <Row className="justify-content-end m-5">
        <Col sm="4" className="mr-4">
          <Row className="justify-content-between pb-1">
            <Col sm="3">Sub Total</Col>
            <Col sm="9">
              <p className="p-0 m-0 text-right">{dollar.format(subTotalTotal)}</p>
            </Col>
          </Row>
        
          <Row className="justify-content-between pb-1">
            <Col sm="3">Sub Discount</Col>
            <Col sm="9">
              <p className="p-0 m-0 text-right">{dollar.format(discountTotal)}</p>
            </Col>
          </Row>
          <Alert color="success">
            <Row className="justify-content-between">
              <Col sm="3">Total</Col>
              <Col sm="9">
                <p className="p-0 m-0 text-right">{dollar.format(totalTotal)}</p>
              </Col>
            </Row>
          </Alert>
        </Col>
      </Row>
    </>
  );
};

export default PurchaseOrderDetail;
